module.exports = __webpack_public_path__ + "img/ep1-1.403796c7.jpg";